enum InformationCategories {
    RecruitmentInformation = 'RecruitmentInformation',
    ProfileSnapshot = 'ProfileSnapshot',
}

export default InformationCategories;
